import React, { FunctionComponent } from 'react'
import { View, ViewStyle } from 'react-native'

import styled from 'styled-components/native'

import { ThemeType } from '../../utils/themes/ThemeProvider'

const BackgroundImage = styled.ImageBackground<{ theme: ThemeType }>(({ theme }) => ({
  width: '100%',
  ...(theme.breakpoints.isMobileSized && { padding: `0 ${theme.spacing['24px']}` }),
  // sizes from laptop up to (but not including) desktop
  ...(theme.breakpoints.isMinWidthLaptop && !theme.breakpoints.isMinWidthDesktop && { padding: '0 100px' }),
  // sizes from tablet up to (but not including) laptop
  ...(theme.breakpoints.isMinWidthTablet &&
    !theme.breakpoints.isMinWidthLaptop && { padding: `0 ${theme.spacing['48px']}` }),
}))

const HomepageContainer = styled.View<{ theme: ThemeType }>(({ theme }) => ({
  height: '100%',
  alignItems: 'center',
  width: '100%',
  ...(theme.breakpoints.isMobileSized && { paddingLeft: theme.spacing['16px'], paddingRight: theme.spacing['16px'] }),
  ...(theme.breakpoints.isMinWidthTablet &&
    !theme.breakpoints.isMinWidthLaptop && { paddingLeft: theme.spacing['48px'], paddingRight: theme.spacing['48px'] }),
  ...(theme.breakpoints.isMinWidthLaptop &&
    !theme.breakpoints.isMinWidthDesktop && { paddingLeft: '100px', paddingRight: '100px' }),
}))

const Overlay = styled.View({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
})

export interface FAQSectionProps {
  ctaAndCollapsibleFAQsSection: JSX.Element
  bottomCTA: JSX.Element
  hasBackgroundImage?: boolean
  backgroundContainerProps?: { [key: string]: any }
  overlayStyle?: ViewStyle
}

export const FAQSection: FunctionComponent<FAQSectionProps> = ({
  ctaAndCollapsibleFAQsSection,
  bottomCTA,
  hasBackgroundImage = false,
  backgroundContainerProps,
  overlayStyle,
}) => {
  const BackgroundContainer = hasBackgroundImage ? BackgroundImage : View

  return (
    // @ts-expect-error TS(2604): JSX element type 'BackgroundContainer' does... Remove this comment to see the full error message
    <BackgroundContainer {...backgroundContainerProps} id='faq'>
      {overlayStyle && <Overlay style={overlayStyle} />}
      <HomepageContainer>
        {ctaAndCollapsibleFAQsSection}
        {bottomCTA}
      </HomepageContainer>
    </BackgroundContainer>
  )
}
